export const isViewerOrLedUser = (
  viewerId: string | null | undefined,
  ledTeamUserIds: readonly string[] | null | undefined,
  userId: string | null | undefined,
): boolean =>
  userId != null &&
  (userId === viewerId || (ledTeamUserIds?.includes(userId) ?? false));
